import { FileQuestion } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

export function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 px-6 text-center">
      <FileQuestion className="text-ink-subtle size-10" aria-hidden />
      <h1 className="text-lg font-semibold">{t('states.notFound')}</h1>
      <Link to="/" className="text-brand-800 text-sm underline underline-offset-4">
        {t('actions.back')}
      </Link>
    </div>
  );
}
